import React, { useState } from 'react'

import clsx from 'clsx'
import moment from 'moment-jalaali'
import { useSelector } from 'react-redux'
import { VisaCancelListByCrewItem } from 'src/types'
import { ChevronDown } from 'src/icons/icons'
import { useTranslation } from 'react-i18next'
import { CancelVisaStatus } from 'src/components/CancelVisaStatus/CancelVisaStatus'
import { CancelVisaOperations } from './CancelVisaOperations'

export const VisaCancelRow = (record: VisaCancelListByCrewItem & {onSuccessMutate:Function}) => {

    const { created_at, id, visa, crew, status, desc, price , onSuccessMutate } = record

    // , automation_number = ''

    // const [isOpen, setIsOpen] = useState<boolean>(false)

    const { t } = useTranslation();

    const user = useSelector((state) => (state as any).user.user)

    const lng = useSelector((state) => (state as any).common.lng)

    const isAgent = user?.role_key === "agent"

    const isAdmin = user?.role_key === "super_admin"


    return (
        <div className='border rounded-xl border-gray-200  flex flex-col  gap-2 mx-4 p-2 ' 
        // onClick={() => setIsOpen(true)}
        >

            <div key={id} className={clsx(` grid  items-center w -full  z-10  ` , isAdmin ? 'grid-cols-9' : 'grid-cols-8' )} >



                <div className="p-3 text-center col-span-1">
                    <div className={"text-gray-500 text-sm mt-1"}>
                        {id}
                    </div>
                </div>
                {/*<div className="p-3 text-center">*/}
                {/*  <div className={"text-gray-500 text-sm mt-1"}>*/}
                {/*    {item?.crew?.nationality}*/}
                {/*  </div>*/}
                {/*</div>*/}
                <div className="p-3 text-center col-span-1">
                    <div className={"text-primary-400 text-sm mt-1 "}>
                        {visa?.subject?? '-'}
                    </div>
                </div>
                {!isAgent && <div className="p-3 text-center col-span-1">
                    <div className={"text-gray-500 text-sm mt-1"}>
                        {/* {(agent?.name ?? '-') + " " + (agent?.last_name ?? '-')} */}-
                    </div>
                </div>}
                <div className="p-3 text-center col-span-1">
                    <div className={clsx("text-gray-500 text-sm mt-1")}>
                        {crew?.name ?? '-'}{crew?.last_name}
                    </div>
                </div>

                <div className="p-3 text-center col-span-1">
                    <div className={"text-gray-500 text-sm mt-1"}>
                        {crew?.job?.name ?? '-'}
                    </div>
                </div>

                <div className="p-3 text-center col-span-1">
                    <div className={"text-gray-500 text-sm mt-1"}>
                        {created_at ? moment(created_at).format(lng === "en" ? "YYYY/MM/DD" : "jYYYY/jMM/jDD") : '-'}
                    </div>
                </div>



                <div className=" py-4 text-start text-gray-500 text-sm font-medium col-span-1">
                    <div className={"mt-1 flex justify-center"}>
                        <CancelVisaStatus status={status} />
                    </div>
                </div>
                {/*<div className=" py-4  text-start text-gray-500 text-sm font-medium col-span-1">
          {
              
              <div className={"flex justify-center" }>
              <div onClick={() => navigate(`/visa-orders/forms/${item?.visa?.id}`)}>
              {!(status === 0 || status === 1) ? <FormIconPure/> : <FormIcon/>}
              </div>
              </div>
            }
            
        </div> */}

                <div className={"text-gray-500 text-sm mt-1 flex-1 text-center "}>
                    <div className={"flex gap-2 justify-center"}>
                        <span>{visa?.automation_number ?? '-'}</span>
                    </div>
                </div>


                {isAdmin && <div className=" py-4 text-start text-gray-500 bg-transparent flex flex-row text-sm font-medium col-span-1 gap-4 justify-evenly overflow-visible">
                  {status==0 &&   <CancelVisaOperations id={id} onSuccessMutate={onSuccessMutate} />}
                    {/* <ChevronDown className={`transition-all duration-300 size-4 text-gray-700 shrink-0 ${isOpen ? '-rotate-180' : ''}`} /> */}
                </div>}

            </div>

            <div className='bg-gray-100 w-full h-[1px]' style={{background:'#e2e2e2'}}></div>

            <div className={`flex flex-col gap-2 items-start transition -all duration- 300 w-full relative text-gray-800 text-right text-sm ${true ? 'translate-y-0 max-h-[1000px] opacity-100' : '-translate-y-full opacity-0 max-h-0 -mt-2'}`}>
                {/* <div className='bg-gray-100 w-full h-[1px]' style={{background:'#e2e2e2'}}> </div> */}
                <p className='p-2'>

                    <span className='text-gray-500'>{t('CancelReason')}</span> : <span>{desc}</span>
                </p>
            </div>
        </div>

        // </div >
    )

}

